import AnchoredPopover from '../../generic/AnchoredPopover';
import Definition from '../grid/Definition';
import * as style from './Popover.module.css';

export interface Props {
    id: string;
    name: string;
    summary?: string;
    url?: string;
    buttonChildren?: React.ReactNode;
}

export default function DefinitionPopover({ id, name, summary, url, buttonChildren }: Props) {
    return (
        <AnchoredPopover className={style.popover} id={`popover-definition-${id}`} data-modal-name="definisjon" buttonChildren={buttonChildren}>
            <Definition name={name} summary={summary} />
            {!!url ? <a href={url}>Vil du lese mer om {name}?</a> : null}
        </AnchoredPopover>
    );
}
